document.addEventListener('DOMContentLoaded', function () {
  const SLOT_DURATION = 800;
  const slotEaseOut = t => 1 - Math.pow(1 - t, 5);

  function animatePrice(spanEl, newText) {
    const newDigits = newText.replace(/[^\d]/g, '');

    if (!spanEl._slotEls || spanEl._slotEls.length !== newDigits.length) {
      spanEl._slotEls = null;
      spanEl._staticEls = null;
      spanEl.textContent = newText;
      spanEl.style.display = '';
      buildSlotDisplay(spanEl);
      const digits = newText.split('').filter(c => /\d/.test(c));
      spanEl._slotEls.forEach((slotEl, i) => {
        const toDigit = parseInt(digits[i]);
        const total = spanEl._slotEls.length;
        const rank = total - 1 - i;
        slotEl._current = toDigit;
        const strip = slotEl._strip;
        const emPx = parseFloat(getComputedStyle(spanEl).fontSize);
        const rowH = emPx;
        const fromY = -10 * rowH;
        const toY = -(toDigit + 10) * rowH;
        strip.style.transition = 'none';
        strip.style.transform = `translateY(${fromY}px)`;
        let startTime = null;
        const step = (now) => {
          if (!startTime) startTime = now;
          const t = Math.min((now - startTime) / SLOT_DURATION, 1);
          strip.style.transform = `translateY(${fromY + (toY - fromY) * slotEaseOut(t)}px)`;
          if (t < 1) {
            slotEl._rafId = requestAnimationFrame(step);
          } else {
            strip.style.transform = `translateY(${-toDigit * rowH}px)`;
            slotEl._current = toDigit;
          }
        };
        if (slotEl._rafId) cancelAnimationFrame(slotEl._rafId);
        setTimeout(() => {
          slotEl._rafId = requestAnimationFrame(() => requestAnimationFrame(() => requestAnimationFrame(step)));
        }, rank * 40);
      });
      return;
    }

    const digits = newText.split('').filter(c => /\d/.test(c));
    const total = spanEl._slotEls.length;

    spanEl._slotEls.forEach((slotEl, i) => {
      const toDigit = parseInt(digits[i]);
      const fromDigit = slotEl._current ?? toDigit;
      if (fromDigit === toDigit) return;

      const rank = total - 1 - i;
      const delayMs = rank * 40;
      slotEl._current = toDigit;

      const strip = slotEl._strip;
      const emPx = parseFloat(getComputedStyle(spanEl).fontSize);
      const rowH = emPx;

      const fromRow = fromDigit + 10;
      let toRow = toDigit + 10;
      if (toRow <= fromRow) toRow += 10;

      const fromY = -fromRow * rowH;
      const toY   = -toRow   * rowH;

      strip.style.transition = 'none';
      strip.style.transform = `translateY(${fromY}px)`;

      let startTime = null;
      const step = (now) => {
        if (!startTime) startTime = now;
        const t = Math.min((now - startTime) / SLOT_DURATION, 1);
        strip.style.transform = `translateY(${fromY + (toY - fromY) * slotEaseOut(t)}px)`;
        if (t < 1) {
          slotEl._rafId = requestAnimationFrame(step);
        } else {
          strip.style.transform = `translateY(${-toDigit * rowH}px)`;
          slotEl._current = toDigit;
        }
      };

      if (slotEl._rafId) cancelAnimationFrame(slotEl._rafId);
      setTimeout(() => {
        slotEl._rafId = requestAnimationFrame(() => requestAnimationFrame(() => requestAnimationFrame(step)));
      }, delayMs);
    });
  }

  function buildSlotDisplay(spanEl) {
    if (spanEl._slotEls) return;
    const text = spanEl.textContent.trim();
    spanEl.textContent = '';
    spanEl.style.cssText += `
      display:inline-flex;
      align-items:baseline;
      line-height:1;
      vertical-align:baseline;
    `;
    spanEl._slotEls = [];
    spanEl._staticEls = [];

    const emPx = parseFloat(getComputedStyle(spanEl).fontSize);
    const rowH = emPx;

    for (const ch of text) {
      if (/\d/.test(ch)) {
        const wrapper = document.createElement('span');
        wrapper.style.cssText = `
          display:inline-block;
          overflow:hidden;
          height:${rowH}px;
          line-height:${rowH}px;
          vertical-align:baseline;
          flex-shrink:0;
          -webkit-mask-image:linear-gradient(
            to bottom,
            transparent 0%,
            black 8%,
            black 92%,
            transparent 100%
          );
          mask-image:linear-gradient(
            to bottom,
            transparent 0%,
            black 8%,
            black 92%,
            transparent 100%
          );
        `;
        const strip = document.createElement('span');
        strip.style.cssText = 'display:flex;flex-direction:column;will-change:transform;';
        for (let rep = 0; rep < 3; rep++) {
          for (let d = 0; d <= 9; d++) {
            const row = document.createElement('span');
            row.style.cssText = `line-height:${rowH}px;height:${rowH}px;display:block;`;
            row.textContent = d;
            strip.appendChild(row);
          }
        }
        wrapper.appendChild(strip);
        wrapper._strip = strip;
        wrapper._rafId = null;
        wrapper._current = parseInt(ch);
        strip.style.transform = `translateY(${-wrapper._current * rowH}px)`;
        spanEl.appendChild(wrapper);
        spanEl._slotEls.push(wrapper);
      } else {
        const s = document.createElement('span');
        s.textContent = ch;
        s.style.cssText = `
          line-height:${rowH}px;
          height:${rowH}px;
          display:inline-block;
          vertical-align:baseline;
          flex-shrink:0;
        `;
        spanEl.appendChild(s);
        spanEl._staticEls.push(s);
      }
    }
  }

  const flashSvgError = (btn) => {
    const svg = btn.querySelector('svg');
    if (!svg) return;
    const originalFill = getComputedStyle(svg).fill;
    svg.dataset.originalFill = originalFill;
    svg.style.transition = 'fill 0.3s ease';
    svg.style.fill = '#d00';
    svg.classList.add('shake-svg');
    setTimeout(() => svg.classList.remove('shake-svg'), 400);
    setTimeout(() => svg.style.removeProperty('fill'), 2000);
  };

  const addAllButton = document.querySelector('.related-add-all');
  const buyNowButton = document.querySelector('.related-buy-now');
  const totalDisplay = document.getElementById('related-total-price');
  const originalDisplay = document.getElementById('related-total-original');
  const checkboxes = document.querySelectorAll('.related-checkbox');
  const mainProductPrice = parseFloat(document.querySelector('.main-product-price')?.dataset.price || 0);
  const mainProductOriginalPrice = parseFloat(document.querySelector('.main-product-price')?.dataset.originalPrice || 0);
  const collapsibleTrigger = document.querySelector('.together-toggle-button');
  const collapsibleContent = document.querySelector('.related-products-wrapper');
  const toggleIcon = collapsibleTrigger?.querySelector('.toggle-icon');

  const addAllSpinner = addAllButton?.querySelector('.related-add-all__spinner');

  function setAddAllLoading(on) {
    if (!addAllButton) return;
    addAllButton.classList.toggle('is-loading', !!on);
    addAllSpinner?.classList.toggle('hidden', !on);
  }

  setAddAllLoading(false);

  let isOpen = true;
  let currentRotation = 180;

  if (collapsibleContent) {
    collapsibleContent.style.maxHeight = 'none';
  }

  function refreshHeight() {
    if (!collapsibleContent || !isOpen) return;
    collapsibleContent.style.maxHeight = 'none';
  }

  collapsibleTrigger?.classList.add('open');

  if (toggleIcon) {
    toggleIcon.style.transform = 'rotate(180deg)';
  }

  if (totalDisplay) buildSlotDisplay(totalDisplay);
  if (originalDisplay) buildSlotDisplay(originalDisplay);

  function updateTotal() {
    let originalTotal = mainProductOriginalPrice || mainProductPrice;
    let discountedTotal = mainProductPrice;
    let hasRelatedSelected = false;

    checkboxes.forEach(cb => {
      const original = cb.dataset.originalPrice !== undefined
        ? parseFloat(cb.dataset.originalPrice)
        : parseFloat(cb.closest('.related-product-item').dataset.originalPrice);
      const discounted = parseFloat(cb.dataset.price);
      if (cb.checked) {
        hasRelatedSelected = true;
        if (!isNaN(original)) originalTotal += original;
        if (!isNaN(discounted)) discountedTotal += discounted;
      }
    });

    const scheme = document.documentElement.getAttribute('data-scheme');
    const isDark = scheme === 'dark';

    if (hasRelatedSelected) {
      if (originalDisplay.style.display === 'none' || originalDisplay.style.display === '') {
        originalDisplay.style.display = 'inline-flex';
        originalDisplay.style.opacity = '0';
        originalDisplay.style.transform = 'translateX(-8px)';
        originalDisplay.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        requestAnimationFrame(() => {
          originalDisplay.style.opacity = '1';
          originalDisplay.style.transform = 'translateX(0)';
        });
      }
      totalDisplay.style.color = '#008b00';
    } else {
      originalDisplay.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
      originalDisplay.style.opacity = '0';
      originalDisplay.style.transform = 'translateX(-8px)';
      setTimeout(() => { originalDisplay.style.display = 'none'; }, 200);
      totalDisplay.style.color = isDark ? '#e0e0e0' : '#000';
    }

    animatePrice(originalDisplay, '₾' + originalTotal.toFixed(2));
    animatePrice(totalDisplay, '₾' + discountedTotal.toFixed(2));
  }

  function updateBorderLineColor() {
    const scheme = document.documentElement.getAttribute('data-scheme');
    const isDark = scheme === 'dark';
    const color = isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.3)';
    const toggleBtn = document.querySelector('.toggle-border-anim');
    if (toggleBtn) toggleBtn.style.setProperty('--border-line-color', color);
  }

  let updateTotalTimer = null;

  checkboxes.forEach(cb => cb.addEventListener('change', () => {
    if (updateTotalTimer) clearTimeout(updateTotalTimer);
    updateTotalTimer = setTimeout(updateTotal, 80);
  }));

  updateTotal();
  updateBorderLineColor();

  const observer = new MutationObserver(() => {
    updateTotal();
    updateBorderLineColor();
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-scheme']
  });

  async function submitSelectedProducts() {
    const wrapper = document.querySelector('.related-products-wrapper');
    if (!wrapper) return;
    const productForms = Array.from(wrapper.querySelectorAll('product-form'));
    for (const productForm of productForms) {
      const isMainProduct = productForm.classList.contains('main-product');
      const checkbox = productForm.querySelector('.related-checkbox');
      if (isMainProduct || (checkbox && checkbox.checked)) {
        const form = productForm.querySelector('form');
        const submitButton = form?.querySelector('button[type="submit"]');
        if (form && submitButton) {
          await simulateSubmit(form, submitButton);
        }
      }
    }
  }

  addAllButton?.addEventListener('click', async function (e) {
    const anyChecked = [...checkboxes].some(cb => cb.checked);
    if (!anyChecked) {
      e.preventDefault();
      flashSvgError(addAllButton);
      return;
    }
    setAddAllLoading(true);
    try {
      await submitSelectedProducts();
    } finally {
      setAddAllLoading(false);
    }
  });

  buyNowButton?.addEventListener('click', async function (e) {
    const anyChecked = [...checkboxes].some(cb => cb.checked);
    if (!anyChecked) {
      e.preventDefault();
      flashSvgError(buyNowButton);
      return;
    }
    await submitSelectedProducts();
    window.location.href = '/checkout';
  });

  function simulateSubmit(form, submitButton) {
    return new Promise((resolve) => {
      const onSubmit = () => {
        form.removeEventListener('submit', onSubmit);
        setTimeout(resolve, 1000);
      };
      form.addEventListener('submit', onSubmit);
      submitButton.click();
    });
  }

  collapsibleTrigger?.addEventListener('click', () => {
    isOpen = !isOpen;
    currentRotation += 180;

    if (isOpen) {
      collapsibleContent.style.maxHeight = collapsibleContent.scrollHeight + 'px';
      collapsibleTrigger.classList.add('open');
      const done = (e) => {
        if (e.propertyName !== 'max-height') return;
        collapsibleContent.style.maxHeight = 'none';
        collapsibleContent.removeEventListener('transitionend', done);
      };
      collapsibleContent.addEventListener('transitionend', done);
    } else {
      collapsibleContent.style.maxHeight = collapsibleContent.scrollHeight + 'px';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          collapsibleContent.style.maxHeight = '0';
        });
      });
      collapsibleTrigger.classList.remove('open');
    }

    toggleIcon.style.transform = `rotate(${currentRotation}deg)`;
  });

  const mainImage = document.getElementById('main-product-image');
  const variantSelectors = document.querySelectorAll('input[type="radio"][name^="options["]');
  if (mainImage && variantSelectors.length) {
    const jsonEl = document.getElementById('ProductVariantsWithImages');
    if (jsonEl) {
      let productData;
      try {
        productData = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return console.warn('JSON?');
      }

      const updateImage = (variantId) => {
        const variant = productData.find(v => v.id == variantId);
        if (variant?.featured_image?.src) {
          mainImage.src = variant.featured_image.src;
        }
        const productForm = document.querySelector('product-form.main-product');
        const idInput = productForm?.querySelector('input[name="id"]');
        if (idInput) idInput.value = variantId;
        const titleLink = document.querySelector('.related-product-title');
        if (titleLink) {
          const url = new URL(titleLink.href, window.location.origin);
          url.searchParams.set("variant", variantId);
          titleLink.href = url.toString();
        }
      };

      const getVariantId = () => {
        const selected = [];
        document.querySelectorAll('[name^="options["]:checked').forEach(input => {
          selected.push(input.value);
        });
        const variant = productData.find(v =>
          v.options.every((opt, i) => opt === selected[i])
        );
        return variant?.id;
      };

      variantSelectors.forEach(input => {
        input.addEventListener('change', () => {
          const id = getVariantId();
          if (id) updateImage(id);
        });
      });

      const productForm = document.querySelector('product-form.main-product');
      const initialId = productForm?.querySelector('input[name="id"]')?.value;
      if (initialId) updateImage(initialId);
    }
  }

  const switchButtons = document.querySelectorAll('.switch-button');

  switchButtons.forEach(button => {
    let alternatives = [];
    try { alternatives = JSON.parse(button.dataset.alternatives) || []; } catch (e) {}

    let currentIndex = parseInt(button.dataset.currentIndex || '-1');
    let busy = false;

    const preloadAll = () => {
      alternatives.map(a => a.image).concat([button.dataset.originalImage])
        .forEach(src => {
          if (!src) return;
          const im = new Image();
          im.decoding = 'async';
          im.src = src;
        });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadAll, { timeout: 2000 });
    } else {
      setTimeout(preloadAll, 500);
    }

    button.addEventListener('click', () => {
      if (busy) return;

      const label = button.closest('label.related-product-item');
      if (!label) return;

      busy = true;
      let heightAnimation = null;

      currentIndex++;
      let alt;
      const isBackToOriginal = currentIndex >= alternatives.length;
      if (isBackToOriginal) {
        alt = {
          id: button.dataset.originalId,
          title: button.dataset.originalTitle,
          url: button.dataset.originalUrl,
          price: Number(button.dataset.originalDiscount),
          original_price: Number(button.dataset.originalPrice),
          image: button.dataset.originalImage
        };
        currentIndex = -1;
      } else {
        alt = alternatives[currentIndex];
      }

      const img = label.querySelector('img.related-product-image');
      const info = label.querySelector('.related-product-info');
      const startH = label.offsetHeight;

      const applyContent = () => {
        if (img && alt.image) { img.src = alt.image; img.alt = alt.title; }

        const title = label.querySelector('.related-product-title');
        if (title && alt.title && alt.url) { title.textContent = alt.title; title.href = alt.url; }

        const price = label.querySelector('.related-product-price > span:first-child');
        const oldPrice = label.querySelector('.related-product-price > span:last-child');
        const roundedPrice = Math.round(Number(alt.price));
        const roundedOriginal = Math.round(Number(alt.original_price));

        if (price) price.textContent = '₾' + (isNaN(roundedPrice) ? '--' : roundedPrice);
        if (oldPrice) {
          oldPrice.textContent = '₾' + (isNaN(roundedOriginal) ? '--' : roundedOriginal);
          oldPrice.style.display = 'inline';
        }

        const form = label.closest('form');
        const hiddenInput = form?.querySelector('input[name="id"]');
        if (hiddenInput && alt.id) hiddenInput.value = alt.id;

        const checkbox = label.querySelector('.related-checkbox');
        if (checkbox && alt.id) {
          checkbox.id = `related_${alt.id}`;
          checkbox.name = `related_${alt.id}`;
          checkbox.dataset.price = isNaN(roundedPrice) ? '0' : roundedPrice;
          checkbox.dataset.originalPrice = isNaN(roundedOriginal) ? '0' : roundedOriginal;
          label.setAttribute('for', `related_${alt.id}`);
          if (checkbox.checked) updateTotal();
        }

        button.dataset.currentIndex = currentIndex;
      };

      const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

      const outAnims = [];
      if (info) {
        outAnims.push(info.animate(
          [{ opacity: 1, transform: 'translateX(0)' },
           { opacity: 0, transform: 'translateX(-14px)' }],
          { duration: 150, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
        ).finished);
      }
      if (img) {
        outAnims.push(img.animate(
          [{ opacity: 1, transform: 'scale(1)' },
           { opacity: 0, transform: 'scale(0.9)' }],
          { duration: 150, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
        ).finished);
      }

      Promise.all(outAnims).catch(() => {}).then(() => {
        applyContent();

        label.style.height = startH + 'px';
        label.style.overflow = 'hidden';
        label.offsetHeight;
        label.style.height = 'auto';
        const endH = label.offsetHeight;
        label.style.height = startH + 'px';

        const heightAnim = (startH !== endH)
          ? (heightAnimation = label.animate(
              [{ height: startH + 'px' }, { height: endH + 'px' }],
              { duration: 320, easing: EASE, fill: 'forwards' }
            )).finished
          : Promise.resolve();

        const inAnims = [];
        if (info) {
          inAnims.push(info.animate(
            [{ opacity: 0, transform: 'translateX(18px)' },
             { opacity: 1, transform: 'translateX(0)' }],
            { duration: 280, easing: EASE, fill: 'forwards', delay: 40 }
          ).finished);
        }
        if (img) {
          inAnims.push(img.animate(
            [{ opacity: 0, transform: 'scale(1.08)' },
             { opacity: 1, transform: 'scale(1)' }],
            { duration: 320, easing: EASE, fill: 'forwards' }
          ).finished);
        }

        return Promise.all([heightAnim].concat(inAnims)).catch(() => {});
      }).then(() => {
        if (heightAnimation) heightAnimation.cancel();
        label.style.height = '';
        label.style.overflow = '';
        if (info) { info.style.opacity = ''; info.style.transform = ''; }
        if (img) { img.style.opacity = ''; img.style.transform = ''; }
        refreshHeight();
        busy = false;
      });
    });
  });
});